var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"graph-transaction"},[_c('v-sparkline',{attrs:{"value":_vm.values,"label-size":"8","labels":_vm.labels,"padding":"16","color":"base","line-width":"4","radius":6,"stroke-linecap":"round","smooth":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }